import B_ImageBG from '../../../../base/dev/child/image/B_ImageBG';

const init = () => {
    return class R_ImageBG extends B_ImageBG {
        constructor(obj) {
            super(obj);

            if (!obj.full) {
                this._w = Math.floor(this._object.getBounds().width * this._object.scaleY);
                this._setArea(
                    this._w,
                    this.CODMOS.CANVAS.height
                );
            }
        }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/child/image/R_ImageBG.js